import { CurveError, CurvePhase, CurveState } from '@gong/curve-math';

export const PHASE_CODE = {
  Initializing: 0,
  Active: 1,
  Graduating: 2,
  Graduated: 3,
} as const;

export function phaseFromContract(phase: number | bigint): CurvePhase {
  const n = Number(phase);
  switch (n) {
    case 0:
      return 'Initializing';
    case 1:
      return 'Active';
    case 2:
      return 'Graduating';
    case 3:
      return 'Graduated';
    default:
      throw new CurveError('notActive', `unknown curve phase ${n}`);
  }
}

export function phaseToContract(phase: CurvePhase): number {
  return PHASE_CODE[phase];
}

export interface OnchainCurveData {
  phase: bigint | number;
  activatedAt: bigint | number;
  realTon: bigint;
  seedTon: bigint;
  excessSeedTon: bigint;
  antiSnipeTon: bigint;
  sold: bigint;
  seedJettons: bigint;
  devBuyJettons: bigint;
  pendingFees?: bigint;
}

/** Map a contract getter into the curve-math state the quote functions consume. */
export function curveStateFromData(data: OnchainCurveData): CurveState {
  const activated = Number(data.activatedAt);
  return {
    phase: phaseFromContract(data.phase),
    realTon: data.realTon,
    seedTon: data.seedTon,
    excessSeedTon: data.excessSeedTon,
    antiSnipeTon: data.antiSnipeTon,
    sold: data.sold,
    seedJettons: data.seedJettons,
    devBuyJettons: data.devBuyJettons,
    activatedAt: activated > 0 ? activated : null,
  };
}

export function canTrade(phase: CurvePhase): boolean {
  return phase === 'Active';
}
